export const getBookButtonTitle = (canBeBooked: boolean): string => {
  return canBeBooked ? 'Бронировать онлайн' : 'Проверить места';
};
